// CardSection.js
import React from "react";
import { CardElement } from "react-stripe-elements";
import { Text } from "rebass";

type Props = {
  disabled: boolean
};

const CardSection = ({ disabled }: Props) => (
  <label htmlFor="cardInput">
    <Text f={[2]} color="support2">
      Credit or debit card
    </Text>
    <CardElement
      name="cardInput"
      style={{ base: { fontSize: "16px" } }}
      disabled={disabled}
    />
  </label>
);

export default CardSection;



// WEBPACK FOOTER //
// ./src/components/Stripe/CardSection.jsx